import { request, useQuery } from '@applyboard/ui-utils';
import { Deserializer } from 'jsonapi-serializer';
import { ApplicationStageChangeReasonResponse } from "../../../types";
export function useApplicationStageChangeReasons(_ref) {
  var _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled;
  var _useQuery = useQuery(['stage_change_reasons', {
      pkg: 'ab-application'
    }], function () {
      return request('/awa/v1/applications/stage_change_reasons', {
        schema: ApplicationStageChangeReasonResponse,
        deserializer: new Deserializer({
          keyForAttribute: 'camelCase'
        })
      });
    }, {
      enabled: enabled
    }),
    data = _useQuery.data,
    status = _useQuery.status;
  return {
    applicationStageChangeReasons: data || [],
    applicationStageChangeReasonsStatus: status
  };
}